module.exports = ".font-14 {\n  font-size: 14px !important; }\n\noption[value=''][disabled] {\n  display: none; }\n"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/settings/integrations-section/modals/integrate-with-xero-v2/integrate-with-xero-v2-modal.scss
// module id = ./web/modern/components/settings/integrations-section/modals/integrate-with-xero-v2/integrate-with-xero-v2-modal.scss
// module chunks = 0